import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ReportContainer from './ReportContainer/ReportContainer'
import PageNotFound from './PageNotFound/PageNotFound'
import Pageheader from './headerComponent/header'
import ErrorComponent from './errorComp/ErrorComponent'
import LogoutComponent from './LogoutComponent/LogoutComponent'
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useSearchParams
} from 'react-router-dom'
import './Customportal.scss'

/**
 * ✅ Handles query params
 */
const GsspRouter = () => {
  const [params] = useSearchParams()

  const cntntid = params.get('cntntid')
  // const userId = params.get('userId')

  // ✅ Validate required params
  if (!cntntid) {
    return <ErrorComponent>
      <PageNotFound />
    </ErrorComponent>
  }

  return (
    <ErrorComponent>
      <ReportContainer cntntid={cntntid} />
    </ErrorComponent>
  )
}

/**
 * ✅ Guard: blocks anything except exact /reports/gssp
 */
const GsspGuard = () => {
  const location = useLocation()

  const isExactPath = location.pathname === '/reports/gssp'

  if (!isExactPath) {
    return <PageNotFound />
  }

  return <GsspRouter />
}

function App () {
  const location = useLocation()
  const [isLoggedOut, setIsLoggedOut] = useState(false)

  useEffect(() => {
    if (location.state?.logout) {
      setIsLoggedOut(true)
    }
  }, [location])

  const handleLogout = (reason = 'Logout') => {
    console.log(reason)
    localStorage.clear()
    sessionStorage.clear()
    setIsLoggedOut(true)
  }

  // ✅ Logout UI
  if (isLoggedOut) {
    return <LogoutComponent />
  }

  return (
    <div className='customportal'>
      <ToastContainer />
      <Pageheader onLogout={handleLogout} />

      <Routes>
        {/* Default */}
        <Route path='/' element={<Navigate to='/reports' replace />} />

        {/* Reports */}
        <Route
          path='/reports'
          element={
            <ErrorComponent>
              <ReportContainer />
            </ErrorComponent>
          }
        />

        {/* ✅ GSSP guarded route */}
        <Route
          path='/reports/gssp'
          element={<GsspGuard />}
        />

        {/* Logout */}
        <Route path='/logout' element={<LogoutComponent />} />

        {/* 404 */}
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </div>
  )
}

export default App
